import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {
	return {
		background: {
			backgroundColor: theme.other.colors?.background[props?.type]
		}
	};
} );